import { useEffect, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { FinanceFormValues, useFinanceFormContext } from '../../context';

export type DepositType = 'select' | 'fixed';

export interface DepositHook {
  depositField: DepositType | undefined;
}

export default function useDeposit(): DepositHook {
  const { job } = useFinanceFormContext();

  const { setValue } = useFormContext<FinanceFormValues>();

  const [apr, duration] = useWatch<FinanceFormValues, ['apr', 'duration']>({
    name: ['apr', 'duration'],
  });

  const depositField = useMemo(() => {
    const show = Boolean(apr) && Boolean(duration);
    if (!show) return undefined;
    return job.deposit_type === 'no_deposit' ? 'select' : 'fixed';
  }, [apr, duration, job]);

  useEffect(() => {
    if (depositField !== 'fixed') return;
    const deposit = job.deposit_value.amount;
    setValue('deposit', deposit);
    setValue('depositPercent', 'fixed');
  }, [job, depositField, setValue]);

  return {
    depositField,
  };
}
